import React from 'react';
import {useTranslation} from 'react-i18next';
import {advertiserText, flagOf} from './mercadoAds';

/**
 * Los anunciantes de una cuenta de Mercado Libre, uno por fila: «{nombre} · {país} ({moneda})» con la
 * bandera. Un vendedor tiene un anunciante por país, cada uno en su moneda: sin el país, dos filas con
 * el mismo nombre no se distinguen.
 */
export function MercadoAdsAdvertiserList({advertisers, className = ''}) {
    const {t} = useTranslation();
    const list = (advertisers || []).filter(Boolean);
    if (list.length === 0) return null;
    return (
        <ul className={`ma-advertisers ${className}`.trim()} data-testid="mercado-ads-advertisers">
            {list.map((advertiser, index) => {
                const flag = flagOf(advertiser);
                return (
                    <li key={advertiser.advertiser_id || advertiser.id || index} className="ma-advertisers__item">
                        {flag && <span className="ma-advertisers__flag" aria-hidden="true">{flag}</span>}
                        <span className="ma-advertisers__name">{advertiserText(t, advertiser)}</span>
                    </li>
                );
            })}
        </ul>
    );
}

export default MercadoAdsAdvertiserList;
